import React from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { CredusText, CredusWrapper, color } from 'ui';

type Props = {
  setTabValue: React.Dispatch<React.SetStateAction<number>>;
  tabValue: number;
};

const ReportTab = ({ tabValue, setTabValue }: Props) => {
  const navigate = useNavigate();
  const content = [' Test Result', 'Proctoring Data'];
  const onTabChange = (index: number) => () => {
    setTabValue(index);
    if (index === 0) navigate('');
    else navigate('proctoring');
  };

  return (
    <CredusWrapper
      mt="2.3rem"
      display="flex"
      justify="center"
      align="center"
      gap="1.5rem"
    >
      {content?.map((item, index) => (
        <Wrapping
          onClick={onTabChange(index)}
          key={index}
          pb="0.8rem"
          cursor="pointer"
          bb={
            tabValue === index
              ? `2px solid${color.primary}`
              : '2px solid transparent'
          }
          w="170px"
        >
          <CredusText align="center" size="md" weight="medium">
            {item}
          </CredusText>
        </Wrapping>
      ))}
    </CredusWrapper>
  );
};

export default ReportTab;

const Wrapping = styled(CredusWrapper)`
  transition: all 0.3s ease-in-out;
  &:hover {
    border-bottom: 2px solid ${color.primary};
  }
`;
